// @ts-nocheck



import React from 'react';



import { budgetVersionApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';



export default ({ filter = {}, ...selectProps }) =>
<AutocompleteSelect
  placeholder="Выберите версию"
  fetch={async (params) => {
    return await budgetVersionApi.fetch({
      ...filter,
      ...params
    });
  }}
  refetchParams={{ filter }}
  fetchSingle={budgetVersionApi.get}
  notFoundText="Версии бюджета не найдены"
  renderOption={(budgetVersion, Option) =>
  <Option key={budgetVersion.id} value={budgetVersion.id}>
        {budgetVersion.name}
      </Option>
  }
  {...selectProps} />;
